import React, { FC } from "react";
import { Typography } from "@mui/material";
import { NavLink, NavLinkProps } from "react-router-dom";
import styled from "@emotion/styled";

interface CompoundProps {
  Item: FC<any>;
}

const Tab: FC & CompoundProps = ({ children }) => {
  return (
    <Container>
      <UL>{children}</UL>
    </Container>
  );
};

Tab.displayName = "Tab";

Tab.Item = ({ children, ...rest }) => (
  <Item>
    <Typography variant="body1" component={NavLink} activeClassName="active" {...rest}>
      {children}
    </Typography>
  </Item>
);

Tab.Item.displayName = "TabItem";

export default Tab;

const Container = styled.div`
  background-color: var(--background-color-primary);
  margin: 4px auto;
  box-shadow: var(--box-shadow);
  border-radius: 4px;
`;

const UL = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  width: 100%;
`;

const Item = styled.li`
  flex: 1;
  padding: 0 1px;
  a {
    display: flex;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
    height: 48px;
    font-size: 16px;
    font-weight: 400;
    /* color: var(--text-color-secondary); */
    border-bottom: 2px solid transparent;
    text-decoration: none;
    transition: all 0.3s ease-in-out;

    &:hover {
      /* color: var(--hover-text-color); */
      /* border-color: var(--hover-text-color); */
      font-weight: 600;
    }

    &.active {
      /* color: var(--hover-text-color); */
      /* border-color: var(--hover-text-color); */
      font-weight: 600;
    }

    @media (max-width: 360px) {
      font-size: 12px;
    }
  }
`;
